module.exports = __webpack_public_path__ + "static/media/markescermoni_juni_2026.9e3678b5.jpg";